export const FETCH_COUNTRIES_REQUEST = "FETCH_COUNTRIES_REQUEST";
export const FETCH_COUNTRIES_SUCCESS = "FETCH_COUNTRIES_SUCCESS";
export const FETCH_COUNTRIES_FAILURE = "FETCH_COUNTRIES_FAILURE";
export const SET_COUNTRY = "SET_COUNTRY";
export const COUNTRY_CODE = "COUNTRY_CODE";
export const SET_LANG = "SET_LANG";
export const SET_CONVERSION_RATE = "SET_CONVERSION_RATE"
export const CURRENCY_CODE = "CURRENCY_CODE";